import { useMutation } from "react-query";
import {
  ResumoCategoriaItem,
  RelatorioComposicaoContasQueryParams,
} from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";
import { OperacaoEnum } from "resources/enums/conta";

function useResumoPorCategoria(
  query: RelatorioComposicaoContasQueryParams,
  operacao: OperacaoEnum
) {
  return useMutation<ResumoCategoriaItem[], AxiosError>(
    [`/v1/relatorios/financeiro/composicao-contas/pdf`, query, operacao],
    async () => {
      const { data } = await http.get<ResumoCategoriaItem[]>(
        operacao === OperacaoEnum.Despesa
          ? "/v1/relatorios/financeiro/composicao-despesas/resumo-categorias"
          : "/v1/relatorios/financeiro/composicao-receitas/resumo-categorias",
        {
          params: query,
        }
      );

      return data;
    }
  );
}

export default useResumoPorCategoria;
